import CoverSection from "./CoverSection.view";

export default CoverSection;
